<button mat-raised-button color="accent" (click)="syncOfflineProcesses()">
  Sincronizar Processos Offline
</button>